export const GET_INTERCOM_ACTION = 'GET_INTERCOM_ACTION';
